import React from 'react'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import _ from 'lodash'

const ChartLegend = ({ analysis, seriesLabels, color, chartMargin }) => (
  <dl
    className={classnames({
      legend: true,
      'bar-hover': analysis.hoveredPyramid !== null
    })}
    style={{ marginLeft: chartMargin.left }}
  >
    {
      _.map(seriesLabels, (name, i) => (
        <dd key={name}>
          <span
            className='swatch'
            style={{ backgroundColor: color(i) }}
          />
          {name}
        </dd>
      ))
    }
  </dl>
)

export default observer(ChartLegend)
